import React, { useEffect, useState } from 'react';

import ModuleCard from '../components/ModuleCard';
import appStoreBadge from '../assets/mobile-icons/appStoreBadge.svg';
import SftGlobalData from '../library/SftGlobalData';
import { TailSpin } from 'react-loader-spinner';
import Colors from '../library/Colors';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const MobileModulesScreen = (props) => {
    const [modules, setModules] = useState([]);
    const [userGroups, setUserGroups] = useState([])
    const [loading, setLoading] = useState(true);
    const [selectedUserGroup, setSelectedUserGroup] = useState('0000')

    useEffect(() => {
        if(props.api !== ""){
            props.changeScreen('Licence');
            let postData = { key: props.api };
            SftGlobalData.post('mobileSettings&action=insertAppSettings', postData).then(response => {
                postData = {
                    key: props.api,
                    categoryType: "module"
                };
                if(selectedUserGroup !== "undefined" && selectedUserGroup !== '0000'){
                    postData.groupId = selectedUserGroup;
                }
                SftGlobalData.post('mobileSettings&action=getAppSettings', postData).then(response => {
                    if(response.data.settings?.length > 0) {
                        setModules(response.data.settings);
                        postData = {
                            key: props.api
                        };
                        SftGlobalData.post('mobileSettings&action=getUserGroups', postData).then(response => {
                            setUserGroups(response.data);
                            setLoading(false);
                        })
                    }else{
                        //the first time this should retry everything from line 45 to 53 in order to try insert en fetch one extra time if that still has no result set modules,usergroups to empty array (ask bert if needed)
                        setModules([]);
                        setUserGroups([]);
                        setLoading(false);
                    }
                });
            });
        }
    },[props.api, selectedUserGroup]);

    const resetHandler = async () => {

        let postData = {
            key: props.api,
            groupId: selectedUserGroup,
            categoryType: "module"
        };
        SftGlobalData.post('mobileSettings&action=resetAppSettings', postData).then(response => {
            setLoading(true);
            postData = {
                key: props.api,
                categoryType: "module"
            };
            if(selectedUserGroup !== "undefined" && selectedUserGroup !== '0000'){
                postData.groupId = selectedUserGroup;
            }
            SftGlobalData.post('mobileSettings&action=getAppSettings', postData).then(response => {
                if(response.data.settings?.length > 0) {
                    setModules(response.data.settings);
                    postData = {
                        key: props.api
                    };
                    SftGlobalData.post('mobileSettings&action=getUserGroups', postData).then(response => {
                        setUserGroups(response.data);
                        setLoading(false);
                    })
                }else{
                    setModules([]);
                    setUserGroups([]);
                    setLoading(false);
                }
            });
        });
    }
    

    const modulesMapper = modules.map(module => {
        let modName = module.mod;
        modName = modName.substring(3);
        let translatedName = module.title_nl;
        switch(props.lang){
            case 'nl':
                translatedName = module.title_nl;
                break;
            case 'fr':
                translatedName = module.title_fr;
                break;
            case 'en':
                translatedName = module.title_en;
                break;
            default:
                translatedName = module.title_nl;
                break;
        }
        return (<ModuleCard key={modName} title={translatedName} setting={modName} checked={module.value} api={props.api} lang={props.lang} groupId={selectedUserGroup} theme={props.theme}/>);
    });

    const userGroupMapper = userGroups.map(userGroup => {
        return (
                <MenuItem key={userGroup.groupid} value={userGroup.groupid}>{userGroup.name}</MenuItem>
        );
    });

    const changeUserGroup = (event) => {
        setSelectedUserGroup(event.target.value);
        setLoading(true);
    }

    const isDark = props.theme === 'dark';

    return (
        <div className={(props.screenWidth) < 600 ? 'not_expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme : 'expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme} >
            <Typography variant="h5" sx={{ fontWeight: 700, textAlign: 'center', mb: 2, color: isDark ? Colors.dark_text : Colors.light_text }}>
                MyFasMan Mobile - Scanner app
            </Typography>

            {loading && <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                <TailSpin
                    height="40"
                    width="40"
                    color={Colors.sft_blue}
                    ariaLabel='loading'
                />
            </Box>}

            {!loading &&
                <FormControl fullWidth size="small" sx={{ mb: 3 }}>
                    <InputLabel id="usergrp-label">{props.t('general')}</InputLabel>
                    <Select
                        labelId="usergrp-label"
                        id="usergrp"
                        label={props.t('general')}
                        value={selectedUserGroup}
                        onChange={changeUserGroup}
                    >
                        <MenuItem value="0000">{props.t('general')}</MenuItem>
                        {userGroupMapper}
                    </Select>
                </FormControl>}

            {!loading &&
                <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 0.5 }}>
                    {modulesMapper}
                    <ModuleCard key={'General'} setting={'General'} title={'General'} api={props.api} lang={props.lang} groupId={selectedUserGroup} theme={props.theme}/>
                </Box>}

            {!loading && modules.length > 0 && selectedUserGroup !== '0000' &&
                <Box sx={{ mt: 2 }}>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={()=>{resetHandler();}}
                        sx={{ backgroundColor: Colors.sft_blue, '&:hover': { backgroundColor: Colors.sft_blue_darker } }}
                    >
                        {props.t('use_general')}
                    </Button>
                </Box>}

            <Stack
                direction="row"
                spacing={3}
                sx={{ mt: 5, mb: 2, justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}
            >
                <a href="https://play.google.com/store/apps/details?id=com.softtouch.myfasmanmobile" target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center' }}>
                    <img border="0" src="https://assets.unlayer.com/projects/0/1665410573694-afbeelding_2022-10-10_160254239.png"
                        alt="Google Play"
                        title=""
                        style={{outline: 'none', textDecoration: 'none', display: 'block', border: 'none', height: '44px', width: 'auto'}}
                    />
                </a>
                <a href="https://apps.apple.com/be/app/myfasman-mobile/id1554095410" target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center' }}>
                    <picture className="mx-auto">
                      <source
                        srcSet={appStoreBadge}
                        media="(prefers-color-scheme: dark)"
                      />
                      <img
                        src={appStoreBadge}
                        alt="App Store"
                        style={{outline: 'none', textDecoration: 'none', display: 'block', border: 'none', height: '44px', width: 'auto'}}
                      />
                    </picture>
                </a>
            </Stack>
        </div>
    );
}



export default MobileModulesScreen;